import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import useSEO from "@/hooks/useSEO";
import Logo from "@/components/common/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useSEO({ title: "Panel de Administración", description: "Acceso al panel de administración de GEMA." });

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  const inputCls = "bg-gema-surface border-white/15 text-white placeholder:text-white/30 rounded-none focus-visible:ring-gema-red";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gema-black px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10"><Logo /></div>
        <div className="border border-white/10 bg-gema-ink p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <Lock className="h-5 w-5 text-gema-red" />
            <h1 className="font-heading font-black uppercase text-xl text-white">Panel de Administración</h1>
          </div>
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <Label className="text-white/70 text-xs uppercase tracking-wider">Correo</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
            </div>
            <div>
              <Label className="text-white/70 text-xs uppercase tracking-wider">Contraseña</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
            </div>
            {error && <p className="text-gema-red text-sm" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full disabled:opacity-60">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Ingresar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
